import { getMsgFromApiErr } from "@api/api";
import getGames, { Game } from "@api/public/get/getGames";
import useRequestState from "@hooks/useRequestState";
import { useCallback, useEffect } from "react";

const useGetGames = (autoSend?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState<Game[]>([]);

  const send = useCallback(async () => {
    setLoading();
    try {
      const games = await getGames();
      setSuccess(games);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [setError, setLoading, setSuccess]);

  useEffect(() => {
    if (autoSend) send();
    // prevents infinite loop
    // eslint-disable-next-line
  }, [autoSend]);

  return { ...reqState, data: reqState.data, send };
};

export default useGetGames;
